// extracted by mini-css-extract-plugin
export default {"filter":"EditQuestion_filter__q8geL","fadeIn":"EditQuestion_fadeIn__QOoyn","tblheader":"EditQuestion_tblheader__-LzQn","btn":"EditQuestion_btn__AZ-45"};